import cn from "classnames"
import React from "react"
import { Button } from "reactstrap"
import "./StandardButton.scss"

export interface IStandardButtonBaseProps {
    variant?: "primary"
    type?: "submit"
    className?: string
    id?: string
    width?: number
    height?: number
    title?: string
    dark?: boolean
    noBorder?: boolean
    noBorderRadius?: boolean
    smallBorderRadius?: boolean
    isGrey?: boolean
    inverted?: boolean
    invertedPurple?: boolean
    invertedPurpleBorder?: boolean
    invertedRed?: boolean
    disabled?: boolean
    isDelete?: boolean
    isPurple?: boolean
    isLarge?: boolean
    isMedium?: boolean
    isWide?: boolean
    isSmall?: boolean
    isTiny?: boolean
    children?: React.ReactNode
}

export interface IStandardButtonProps extends IStandardButtonBaseProps {
    onClick?: (event: React.MouseEvent<any, MouseEvent>) => void
}

export const StandardButton = ({
    className,
    dark,
    noBorder,
    noBorderRadius,
    smallBorderRadius,
    isGrey,
    inverted,
    invertedPurple,
    invertedPurpleBorder,
    invertedRed,
    onClick,
    id,
    width,
    height,
    title,
    disabled,
    isDelete,
    isPurple,
    isLarge,
    isMedium,
    isSmall,
    isWide,
    isTiny,
    type,
    variant,
    children,
}: IStandardButtonProps) => {
    const widthProp = width ? { width: width + "px" } : {}
    const heightProp = height ? { height: height + "px" } : {}
    return (
        <Button
            onClick={onClick}
            id={id}
            className={cn(
                "swiipe-standard-button swiipe-btn",
                {
                    "swiipe-btn-white": inverted && !isDelete && !isPurple,
                    "swiipe-btn-inv-purple": invertedPurple && !isDelete && !isPurple,
                    "swiipe-btn-inv-purple-border": invertedPurpleBorder && !isDelete && !isPurple,
                    "swiipe-btn-inv-red": invertedRed && !isDelete && !isPurple,
                    "swiipe-btn-dark": dark,
                    "border-0": noBorder,
                    "border-radius-0": noBorderRadius,
                    "border-radius-4": smallBorderRadius,
                    inverted,
                    "small-btn": isSmall,
                    "tiny-btn": isTiny,
                    delete: isDelete,
                    grey: isGrey,
                    purple: isPurple,
                    wide: isWide,
                    large: isLarge,
                    medium: isMedium,
                },
                className
            )}
            style={{ ...widthProp, ...heightProp }}
            variant={variant || "primary"}
            disabled={disabled}
            type={type}
        >
            {title}
            {children}
        </Button>
    )
}
